/** @jsx h */
// @flow
import { h } from 'preact';
import { styled } from 'goober';

type Props = {
  dotSize?: number,
  dotGap?: number,
  minOpacity?: number,
  maxOpacity?: number,
  backgroundColor?: string,
  scaleSize?: number,
  applyOpacity?: boolean,
};

const LoaderContainer = styled('div')(
  (props) => `
    .loader-dot {
      display: inline-block;
      vertical-align: middle;
      width: ${props.dotSize}px;
      height: ${props.dotSize}px;
      margin: 5px ${props.dotGap / 2}px;
      border-radius: 50%;
      animation: loading-dot 2s infinite;
      transform-origin: bottom;
      opacity: ${props.applyOpacity ? props.minOpacity : 1};
      background-color: ${props.backgroundColor};
      &:nth-child(2) {
        animation-delay: 0.25s;
      }
      &:nth-child(3) {
        animation-delay: 0.5s;
      }
      &:nth-child(4) {
        animation-delay: 0.75s;
      }
  
      @keyframes loading-dot {
        0% {
          transform: scale(1);
        }
        25% {
          transform: scale(${props.scaleSize}) translateY(-4px);
          opacity: ${props.applyOpacity ? props.maxOpacity : 1};
        }
        50% {
          transform: scale(1);
          opacity: ${props.applyOpacity ? props.minOpacity : 1};
        }
        100% {
          transform: scale(1);
          opacity: ${props.applyOpacity ? props.minOpacity : 1};
        }
      }
    }
  `,
);

const SaLoader = (props: Props) => {
  return (
    <LoaderContainer {...props}>
      <span className='loader-dot' />
      <span className='loader-dot' />
      <span className='loader-dot' />
      <span className='loader-dot' />
    </LoaderContainer>
  );
};

SaLoader.defaultProps = {
  dotSize: 8,
  dotGap: 10,
  applyOpacity: true,
  minOpacity: 0.1,
  maxOpacity: 1,
  backgroundColor: '#ffffff',
  scaleSize: 1.4,
};

export default SaLoader;



// WEBPACK FOOTER //
// ./components/salesApp/SaLoader.js